import React from 'react';
import DatePicker from 'components/shared/index/filters/date_picker';
import DateRangeFormat from 'components/insights/_shared/DateRangeFormat';
import { useFilterControl } from 'components/shared/FilterContext';
import FilterToggleButton from '../shared/FilterToggleButton';

const defaultState = {
  start: null,
  end: null,
};

const dateFilter = {
  name: 'date',
  defaultState,
  mapValueToSelected(date) {
    return date.start || date.end ? date : null;
  },
  renderSelected(date) {
    return <DateRangeFormat start={date.start} end={date.end} />;
  },
  removeSelected() {
    return defaultState;
  },
};

const DateRange = () => {
  const [selectedDate, setSelectedDate] = useFilterControl(dateFilter);

  return (
    <DatePicker
      wrapperClassName="pos-r d-ib ml-16"
      popoverClassName=""
      applyCallback={setSelectedDate}
      startDate={selectedDate.start}
      endDate={selectedDate.end}
      renderToggle={({ toggle }) => (
        <FilterToggleButton onClick={toggle}>
          {t('insights.filters.filter_by_date')}
        </FilterToggleButton>
      )}
    />
  );
};

export default DateRange;
